/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientHistoryViewModel } from './PatientHistoryViewModel'; 

export function getPatientHistoryOptions(stayId: string, onSuccess?: (result: PatientHistoryViewModel) => void) {
	return queryOptions({
		queryKey: ['patient-history', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/demographics/history/queries/getpatienthistory/' + stayId;
			const resp = await axios.get<PatientHistoryViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}